import * as React from 'react'

const MOBILE_BREAKPOINT = 768

const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

type Breakpoint = keyof typeof BREAKPOINTS

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}

export function useMediaQuery(breakpoint: Breakpoint) {
  const [matches, setMatches] = React.useState<boolean | undefined>(undefined)
  const breakpointValue = BREAKPOINTS[breakpoint]

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${breakpointValue}px)`)
    const onChange = () => {
      setMatches(window.innerWidth >= breakpointValue)
    }
    mql.addEventListener('change', onChange)
    setMatches(window.innerWidth >= breakpointValue)
    return () => mql.removeEventListener('change', onChange)
  }, [breakpointValue])

  return !!matches
}
